<h1 mat-dialog-title>{{ title }}</h1>
<div mat-dialog-content>
  <form [formGroup]="formwithdraw" autocomplete="off" style="min-width: 230px; min-height: 150px; width: 100%;">
    <mat-form-field appearance="outline" style="width: 100%;">
      <mat-label>Withdraw Reason</mat-label>
      <select matNativeControl id="eventtype" name="eventtype" formControlName="eventtype">
        <option value="">-- Select One --</option>
        <option *ngFor="let item of data.reasonoptions" [ngValue]="item.value">{{ item.label }}</option>
      </select>
      <mat-error *ngIf="onWithrawControlValidators('eventtype')">
        Reason type required
      </mat-error>
    </mat-form-field>
    <mat-form-field [hidden]="!(formwithdraw.value.eventtype == '700000003')" appearance="outline" style="width: 100%;">
      <mat-label>Other Reason</mat-label>
      <textarea  matInput placeholder="Enter Reason for Other" id="otherreason"
        name="otherreason" formControlName="otherreason" maxlength="2000" rows="5"></textarea>
    </mat-form-field>
  </form>
</div>
<div mat-dialog-actions style="margin-top: 9px !important; float: right !important;">
  <button mat-button (click)="onClickCancel()">CANCEL</button>
  <button mat-flat-button (click)="onSave()" [mat-dialog-close]="data" [disabled]="formwithdraw.pristine || formwithdraw.invalid">
    SAVE
  </button>
  
</div>
